var Gsap = (function($) {
  function initGsap() {
    gsap.registerPlugin(ScrollTrigger);

    // ---------------------------------------------
    // Green Block — Entrada de imagen (fade + scale)
    // ---------------------------------------------
    const image = document.querySelector(".green-block__image");

    if (image) {
      gsap.fromTo(
        image,
        {
          opacity: 0,
          scale: 0.96,
        },
        {
          opacity: 1,
          scale: 1,
          duration: 1.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".green-block-1",
            start: "top 60%",
            toggleActions: "play none none none",
          },
        },
      );

      // ---------------------------------------------
      // Green Block — Parallax de imagen
      // ---------------------------------------------
      gsap.fromTo(
        image,
        {
          yPercent: -10,
        },
        {
          yPercent: 15,
          ease: "none",
          scrollTrigger: {
            trigger: ".green-block-1",
            start: "top 70%",
            end: "bottom top",
            scrub: true,
          },
        },
      );
    }

    // ---------------------------------------------
    // Green Block — Circle timeline (ping-pong)
    // ---------------------------------------------
    const circle = document.querySelector("#timeline-circle");
    const wrapper = document.querySelector(".green-block-timeline-wrapper");

    if (circle && wrapper) {
      const getDistance = () => {
        const wrapperWidth = wrapper.offsetWidth;
        const circleWidth = circle.offsetWidth;

        return Math.max(0, (wrapperWidth - circleWidth) * 0.97);
      };

      gsap.set(circle, {
        x: 0,
      });

      const circleLoop = gsap.to(circle, {
        x: getDistance,
        duration: 2,
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true,
        paused: true,
        invalidateOnRefresh: true,
      });

      ScrollTrigger.create({
        trigger: ".green-block-timeline",
        start: "top bottom",
        end: "bottom top",

        onEnter: () => circleLoop.play(),
        onEnterBack: () => circleLoop.play(),

        onLeave: () => circleLoop.pause(),

        onLeaveBack: () => {
          circleLoop.pause(0);
        },
      });

      $(window).on("resize.greenBlock", function() {
        circleLoop.invalidate();
        ScrollTrigger.refresh();
      });
    }
  }

  function init() {
    if (!$(".green-block").length) return;

    initGsap();
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(document).ready(Gsap.init);
